import { render, staticRenderFns } from "./hotCity.vue?vue&type=template&id=54823746&"
import script from "./hotCity.vue?vue&type=script&lang=js&"
export * from "./hotCity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports